import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Popover, Box, FormControl, MenuItem, Select, SelectChangeEvent, ListItemText, Checkbox } from "@mui/material";
import { DownloadXmlProperties, DownloadXmlProperty } from "../../Services/Properties";
import { useTranslation } from "react-i18next";


const DownloadProperty: React.FunctionComponent<{ propertyId: any }> = (props) => {


    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const [selectedPlatform, setSelectPlatform] = useState<any[]>([]);
    const [platforms, setPlatforms] = useState<any>([{ name: "Coralytics", src: "/assets/images/icons/coralytics.webp" }, { name: "Propcrm", src: "/assets/images/icons/propcrm.png" }, { name: "Propertyfinder", src: "/assets/images/icons/finder.png" },{ name: "Propstar", src: "/assets/images/icons/Logo-Properstar-main-RGB.webp" }, { name: "Bayut", src: "/assets/images/icons/bayut.png" }, { name: "Dubizzle", src: "/assets/images/icons/dubizzle.png" }]);
    const [isSpinner, setIsSpinner] = useState<boolean>(false);
     const { t } = useTranslation();


    const handleChangePlatforme = (event: SelectChangeEvent<typeof selectedPlatform>) => {
        const {
            target: { value },
        } = event;

        setSelectPlatform(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    /************Download Xml************ */

    const handleDownload = async () => {
        setIsSpinner(true)
        if (props.propertyId) {
            for (let index = 0; index < selectedPlatform.length; index++) {
                const element = selectedPlatform[index];
                const xmldata = await DownloadXmlProperty([element], props.propertyId)
                const blob = new Blob([xmldata], { type: 'text/xml' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${"Properties_" + element}.xml`;
                a.click();
                URL.revokeObjectURL(url);
                if (index == selectedPlatform.length - 1) {
                    setSelectPlatform([])
                    setIsSpinner(false)
                }
            }
        }
    };


    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const HandlePDF = () => {
        window.open(`/create-property-report/${props.propertyId}`, '_blank');
    }

    return (
        <>
            <Box>
                <button
                    aria-describedby={id}
                    onClick={handleClick}
                    className="button-reset border-4F52C1 border-6 back-E0E7FF color-4F52C1 bold-700 padd-5-15-mb padd-15-30 marg-right-16">
                    {t("propertiesPage.download")}
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_830_5349)">
                            <path d="M4 5.25L7.5 8.75L11 5.25" stroke="#4F46E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_830_5349">
                                <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                            </clipPath>
                        </defs>
                    </svg>

                </button>

                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    PaperProps={{
                        sx: {
                            padding: 0,
                            overflow: "visible",
                            background: "#FFFFFF",
                            marginTop: "15px",
                            boxShadow: " 0px 4px 48px rgba(0, 0, 0, 0.08)",
                            filter: "drop-shadow(0px 4px 48px rgba(0, 0, 0, 0.15))",
                            borderRadius: "12px",
                        },
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            backgroundColor: "white",
                            padding: "10px 5px",
                            borderRadius: "7px"
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: "-10px",
                                left: "80%",
                                width: "0",
                                height: "0",
                                borderLeft: "10px solid transparent",
                                borderRight: "10px solid transparent",
                                borderBottom: "10px solid white",
                                transform: "translateX(-80%)",
                            }}
                        />
                        <Button
                            sx={{
                                background: "#FFFFFF",
                                border: "1px solid rgba(0, 0, 0, 0.2)",
                                borderRadius: "7px",
                                fontFamily: 'Plus Jakarta Sans',
                                fontStyle: "normal",
                                fontWeight: "700",
                                fontSize: "14px",
                                lineHeight: "18px",
                                color: "#000000 !important",
                                padding: "8px 16px",
                                margin: "0 10px",
                                textTransform: "none",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#DownloadProperty"
                            onClick={handleClose}
                        >
                            XML
                        </Button>
                        <Button
                            sx={{
                                background: "#FFFFFF",
                                border: "1px solid rgba(0, 0, 0, 0.2)",
                                borderRadius: "7px",
                                fontFamily: 'Plus Jakarta Sans',
                                fontStyle: "normal",
                                fontWeight: "700",
                                fontSize: "14px",
                                lineHeight: "18px",
                                color: "#000000 !important",
                                padding: "8px 16px",
                                margin: "0 10px",
                                textTransform: "none",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                            onClick={HandlePDF}

                        >
                            PDF
                        </Button>
                    </Box>
                </Popover >
            </Box >

            <div className="modal fade" id="DownloadProperty" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="title-18 ">{t("propertiesPage.titleDownload")}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="platform" className="para-16 mb-3"> {t("propertiesPage.selectPlatform")}</label>
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="demo-multiple-checkbox-label"
                                            id="demo-multiple-checkbox"
                                            multiple
                                            className="custom-select "
                                            value={selectedPlatform}
                                            onChange={handleChangePlatforme}
                                            renderValue={(selected) => selected.join(', ')}>
                                            {platforms.map((platform: any, index: any) => (
                                                <MenuItem value={platform.name} key={index}>
                                                    <Checkbox checked={selectedPlatform.indexOf(platform.name) > -1} />
                                                    <img src={platform.src} style={{ width: "auto", maxHeight: "20px", marginRight: "10px" }} />
                                                    <ListItemText primary={platform.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={handleDownload} data-bs-dismiss="modal" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15 marg-right-16">
                                 {t("propertiesPage.download")}</button>
                            <button type="button" className="button-dash btn-outline-secondary back-trans padd-15 " data-bs-dismiss="modal">
                                {t("propertiesPage.close")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default DownloadProperty;